import { FormRow, MediumFormRow, BigFormRow } from 'framework/ui/layout';
import {
  RemovableInputWrapper,
  DefaultInputPropTypes,
  TextArea,
  TextInput,
  useInputHelper,
  useFormValidation,
} from 'framework/form';
import EducationTypeInput from './EducationTypeDropdown';
import EducationalDocumentInput from './EducationalDocumentInput';

interface EducationInputProps extends DefaultInputPropTypes<any> {
  isAdditionalInfoVisible?: boolean;
}

const EducationInput = ({ isAdditionalInfoVisible = true, ...props }: EducationInputProps) => {
  const { getValue } = useInputHelper(props);
  const educationData = getValue();

  const sourcePrefix = props.source ? `${props.source}.` : '';
  const documentSource = `${sourcePrefix}document`;

  const typeValidation = useFormValidation(`${sourcePrefix}type`);
  const providerNameValidation = useFormValidation(`${sourcePrefix}providerName`);
  const graduationYearValidation = useFormValidation(`${sourcePrefix}graduationYear`);
  const specializationValidation = useFormValidation(`${sourcePrefix}specialization`);
  const assignedQualificationValidation = useFormValidation(`${sourcePrefix}assignedQualification`);
  const additionalInformationValidation = useFormValidation(`${sourcePrefix}additionalInformation`);

  return (
    <>
      <FormRow>
        <EducationTypeInput
          source={`${sourcePrefix}type`}
          label="Education type"
          value={educationData.type}
          placeholder="Education Type"
          isRequired={typeValidation.isRequired()}
        />
        <TextInput
          source={`${sourcePrefix}providerName`}
          label="Education provider"
          value={educationData.providerName}
          isRequired={providerNameValidation.isRequired()}
        />
        <TextInput
          source={`${sourcePrefix}graduationYear`}
          label="Graduation year"
          value={educationData.graduationYear}
          isRequired={graduationYearValidation.isRequired()}
        />
        <TextInput
          source={`${sourcePrefix}specialization`}
          value={educationData.specialization}
          isRequired={specializationValidation.isRequired()}
        />
      </FormRow>
      <MediumFormRow>
        <TextInput
          source={`${sourcePrefix}assignedQualification`}
          value={educationData.assignedQualification}
          label="Assigned qualification"
          isRequired={assignedQualificationValidation.isRequired()}
        />
      </MediumFormRow>
      {isAdditionalInfoVisible && (
        <MediumFormRow>
          <TextArea
            source={`${sourcePrefix}additionalInformation`}
            value={educationData.additionalInformation}
            label="Additional information"
            isRequired={additionalInformationValidation.isRequired()}
          />
        </MediumFormRow>
      )}
      <BigFormRow>
        <div className="education-document__wrapper">
          <RemovableInputWrapper
            addText="Add document"
            deleteText="Remove document"
            source={`${sourcePrefix}haveDocument`}
            value={educationData.haveDocument}
          >
            <EducationalDocumentInput source={documentSource} value={educationData.document} />
          </RemovableInputWrapper>
        </div>
      </BigFormRow>
    </>
  );
};

export default EducationInput;
